var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.968,
    height: 14.743,
    viewBox: "0 0 20.968 14.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.125,76H1.843A1.845,1.845,0,0,0,0,77.843V88.9a1.845,1.845,0,0,0,1.843,1.843H19.125A1.845,1.845,0,0,0,20.968,88.9V77.843A1.845,1.845,0,0,0,19.125,76Zm-.283,1.229L10.96,85.137a.717.717,0,0,1-.952,0L2.126,77.229ZM1.229,88.675V78.069l5.286,5.3Zm.9.84,5.256-5.273L9.138,86a1.944,1.944,0,0,0,2.692,0l1.756-1.762,5.256,5.273Zm17.614-.84-5.286-5.3,5.286-5.3Z",
    transform: "translate(0 -76)",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.12038040075d8556efc75b602a5931c6.svg";
export { ForwardRef as ReactComponent };